
import UploadAreaOne from '@/components/Base/UploadAreas/UploadAreaOne.vue'

export default {
  components: { UploadAreaOne },
  data() {
    return {
      loading: false,
      alert: {
        show: false,
        message: '',
        variant: '',
      },
      formData: {
        name: '',
        phone: '',
        email: '',
        address: '',
        serialNumber: '',
        problem: '',
      },
      selectedFiles: [],
    }
  },
  methods: {
    showAlert(message, variant) {
      this.alert = {
        show: true,
        message,
        variant,
      }
      setTimeout(() => {
        this.alert.show = false
      }, 5000)
    },

    handleFileChange(filesChanged) {
      const files = Array.from(filesChanged)
      if (files.length > 5) {
        this.showAlert('Maximum 5 files allowed', 'error')
        return
      }
    },
    resetForm() {
      this.formData = {
        name: '',
        phone: '',
        email: '',
        address: '',
        serialNumber: '',
        problem: '',
      }
      this.selectedFiles = []
    },

    async sendTechnicalSupport() {
      this.loading = true

      try {
        const formData = new FormData()
        formData.append('formData', JSON.stringify(this.formData))
        const files = this.$refs.uploadArea.fileList
        files.forEach((file) => {
          formData.append('files', file)
        })

        const response = await this.$axios.post(
          '/api/technical-support',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        )

        this.showAlert(
          'Your technical support request has been sent successfully!',
          'success'
        )
        this.$refs.uploadArea.fileList = []
        this.resetForm()
      } catch (error) {
        this.showAlert('Failed to send request. Please try again.', 'error')
        console.error(error)
      } finally {
        this.loading = false
      }
    },
  },
}
